import React, {useMemo} from "react";
import { useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Button from "../../../../component/button/Button";
import Input from "../../../../component/input/Input";
import Select from "../../../../component/multiSelect/MultiSelect";

const OptionSixJobFilter = (props: any) => {
    const location = useLocation();
    const routeParams = useParams();
    const cliendConfig = useSelector((state: any) => state.careers.cliendConfig);
    const langLabels = cliendConfig?.data?.data?.clientSettings?.languageSettings;
    const searchLangLabels = langLabels?.searchSection?.[0];
    const { filter, tableControl, setTableControl, searchControlSubmit } = props;

    const primaryColor = cliendConfig?.data?.data?.clientSettings?.primaryColor || "#d0b06e";
    const secondaryColor = cliendConfig?.data?.data?.clientSettings?.secondaryColor || "#1a2432";

    const opt6SelectStyles = useMemo(() => ({
        control: (styles: any, { isFocused }: any) => ({
            ...styles,
            minHeight: "44px",
            background: "#101722",
            border: `1px solid ${isFocused ? primaryColor : "#273446"}`,
            borderRadius: "8px",
            boxShadow: isFocused ? `0 0 0 1px ${primaryColor}40` : "none",
            "&:hover": { borderColor: primaryColor },
            cursor: "pointer",
        }),
        menu: (styles: any) => ({
            ...styles,
            background: "#101722",
            border: "1px solid #273446",
            borderRadius: "8px",
            marginTop: "6px",
            zIndex: 20,
        }),
        menuList: (styles: any) => ({
            ...styles,
            padding: "4px",
        }),
        option: (styles: any, { isFocused, isSelected }: any) => ({
            ...styles,
            background: isSelected
                ? `${primaryColor}28`
                : isFocused
                ? "#1c2535"
                : "transparent",
            color: isSelected ? primaryColor : "#d6dce7",
            padding: "10px 12px",
            borderRadius: "6px",
            fontSize: "14px",
            cursor: "pointer",
            ":active": {
                background: `${primaryColor}28`,
                color: primaryColor,
            },
        }),
        placeholder: (styles: any) => ({
            ...styles,
            color: "#7f8da3",
            margin: 0,
        }),
        valueContainer: (styles: any) => ({
            ...styles,
            padding: "6px 12px",
            gap: "4px",
        }),
        singleValue: (styles: any) => ({
            ...styles,
            color: "#d6dce7",
        }),
        input: (styles: any) => ({
            ...styles,
            color: "#d6dce7",
            margin: 0,
            padding: 0,
        }),
        multiValue: (styles: any) => ({
            ...styles,
            background: `${primaryColor}22`,
            border: `1px solid ${primaryColor}55`,
            borderRadius: "999px",
            margin: "0",
        }),
        multiValueLabel: (styles: any) => ({
            ...styles,
            color: "#d6dce7",
            paddingLeft: "8px",
            paddingRight: "4px",
            fontSize: "13px",
        }),
        multiValueRemove: (styles: any) => ({
            ...styles,
            borderRadius: "999px",
            ":hover": {
                background: primaryColor,
                color: "#111722",
            },
        }),
        indicatorSeparator: () => ({ display: "none" }),
        dropdownIndicator: (styles: any) => ({
            ...styles,
            color: "#8b96a9",
            paddingRight: "10px",
        }),
    }), [primaryColor, secondaryColor]);

    return (
        <section className={`option6-filter ${location.pathname === `/view/${routeParams?.id}` ? "is-job-view" : ""}`}>
            <div className="option6-filter-grid">
                <div className="option6-field option6-field-search">
                    <Input
                        className="form-control option6-input"
                        type={"text"}
                        value={tableControl.searchText}
                        placeholder={searchLangLabels?.searchPlaceholder ? `${searchLangLabels?.searchPlaceholder}...` : "Search roles..."}
                        name={searchLangLabels?.search}
                        onChange={(e: { target: { value: any } }) => {
                            setTableControl((prs: any) => ({
                                ...prs,
                                searchText: e.target.value
                            }));
                        }}
                    />
                </div>

                <div className="option6-field">
                    <Select
                        isSearchable={true}
                        className="joblist-multi-select option6-select"
                        placeholder={searchLangLabels?.category || "All Departments"}
                        isMulti={true}
                        onChange={(e: any) => {
                            setTableControl((prs: any) => ({
                                ...prs,
                                searchCat: e
                            }));
                        }}
                        value={tableControl.searchCat}
                        options={filter.jobCategories || []}
                        customStyles={opt6SelectStyles}
                    />
                </div>

                <div className="option6-field">
                    <Select
                        isSearchable={true}
                        className="joblist-multi-select option6-select"
                        placeholder={searchLangLabels?.locations || "All Locations"}
                        isMulti={true}
                        onChange={(e: any) => {
                            setTableControl((prs: any) => ({
                                ...prs,
                                searchLocation: e
                            }));
                        }}
                        value={tableControl.searchLocation}
                        options={filter.jobLocations || []}
                        customStyles={opt6SelectStyles}
                    />
                </div>

                <div className="option6-field">
                    <Select
                        isSearchable={true}
                        className="joblist-multi-select option6-select"
                        placeholder={searchLangLabels?.jobTypes || "Job Type"}
                        isMulti={true}
                        onChange={(e: any) => {
                            setTableControl((prs: any) => ({
                                ...prs,
                                searchJob: e
                            }));
                        }}
                        value={tableControl.searchJob}
                        options={filter.jobTypes || []}
                        customStyles={opt6SelectStyles}
                    />
                </div>

                <div className="option6-field option6-action">
                    <Button
                        clasName="btn option6-search-btn"
                        label={searchLangLabels?.search || "Search"}
                        position="left"
                        icon="pi pi-search"
                        onClick={() => searchControlSubmit()}
                    />
                </div>
            </div>
        </section>
    );
};

export default OptionSixJobFilter;
